import Cookies from 'js-cookie';
import { AIDT_LOGIN_AUTH_PARTNER_ID, AIDT_API_DOMAIN } from '@shared/constants/token';
import { loginWithToken } from '@shared/utils/auth';
import { decode } from 'js-base64';
import { AidtLoginMutation } from './aidtLogin.generated';

export function setLoginAidtCookie(loginAidt: AidtLoginMutation['loginAidt']) {
  if (loginAidt?.token) loginWithToken(loginAidt.token);
  if (loginAidt?.partnerId) Cookies.set(AIDT_LOGIN_AUTH_PARTNER_ID, decode(loginAidt.partnerId));
  if (loginAidt?.apiDomain) Cookies.set(AIDT_API_DOMAIN, loginAidt.apiDomain);
}
